import { useNavigator } from '@repo/toolkit/use-navigator'
import Box from '@repo/ui/box'
import { ProviderIcon } from '@repo/ui/icons'
import { useMutation } from '@tanstack/react-query'
import { toast } from 'sonner'

import { createTripProvider } from '../../api/trip-providers/create-trip-provider'
import UserNavBar from '../../components/elements/nav-bar'
import TripProviderForm from '../../components/pages/trip-providers/trip-provider-form'
import { Paths } from '../../lib/constants/path'
import { twoButtonsConfig } from '../../lib/utils/buttons-config/validation-buttons-config'
import { showAxiosError } from '../../lib/utils/functions/misc.functions'

const TripProviderCreatePage = () => {
  const { navigate, back } = useNavigator()

  const { mutateAsync } = useMutation({
    mutationFn: createTripProvider,
    onError: showAxiosError,
    onSuccess: () => toast.success('Prestataire de voyage créé avec succès')
  })

  return (
    <div>
      <UserNavBar title={'Créer un nouveau prestataire de voyage'} icon={ProviderIcon} />
      <div className={'h-4'} />

      <Box>
        <TripProviderForm
          buttonsConfig={twoButtonsConfig({
            onConfirm: async (values) => {
              const res = await mutateAsync(values)
              navigate(Paths.TRIP_PROVIDER_UPDATE_PAGE.replace(':id', res.id.toString()), {
                replace: true
              })
            },
            onCancel: () => back(Paths.TRIP_PROVIDER_LIST_PAGE)
          })}
        />
      </Box>
    </div>
  )
}

export default TripProviderCreatePage
